import { schema } from "normalizr";
import { countriesTypes } from "../types";
import Resource from "./resource";

const countrySchema = new schema.Entity("countries");

export default new Resource("/countries", countriesTypes, countrySchema);
